import React from "react";
import TableRow from "@material-ui/core/TableRow";
// callbacks should be an object where each key represents a function
const CreateTableRows = (records, order, columns, callbacks) => {
  if (!records) {
    return null;
  }

  return (
    records.map(x => <TableRow key={x.id} hover>
      {columns.map(({ id, Cell }) => {
        if (!Cell) {
          throw new Error("Must provide a cell template for a colummn");
        }

        return <Cell key={id} record={x} callbacks={callbacks} />;
      })}
                     </TableRow>)
  );
};

export default CreateTableRows;
